'use client';

import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

export interface AnimatedNumberTypography {
	value: number;
	className?: string;
	includesComma?: boolean;
	suffix?: string;
	format?(value: number): string;
	onStart?(): void;
	onEnd?(): void;
}

export default function AnimatedNumberTypography({ value, className, includesComma = true, suffix, format, onStart, onEnd }: AnimatedNumberTypography) {
	const { ref, inView } = useInView({ threshold: 0.5, triggerOnce: true });

	return (
		<div ref={ref}>
			{inView && <CountUp className={className} start={0} end={value} duration={3} decimal={includesComma ? ',' : ''} formattingFn={format} suffix={suffix} onStart={onStart} onEnd={onEnd} />}
		</div>
	);
}
